import { defaultColumnWidths } from "@/lib/interfaces and Enums/ENUMColumnWidths";
import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import { InstrumentTypeCode } from "@/lib/interfaces and Enums/ENUMInstrumentTypeCode";
import { SecurityTypeCode } from "@/lib/interfaces and Enums/ENUMSecurityTypeCode";
import { StrategyType } from "@/lib/interfaces and Enums/ENUMStrategyType";
import { StructureTypeCode } from "@/lib/interfaces and Enums/ENUMStructureTypeCode";
import { TableHeaderField } from "@/lib/interfaces and Enums/ENUMTableHeaders";
import { TradeType } from "@/lib/interfaces and Enums/ENUMTradeType";
import { fillerColDef } from "@/lib/fillerColDef";
import {
  returnPercentageFormatted,
  returnSizeFormatted,
} from "@/lib/globalFormatterHelper";
import { updateSettlementDate } from "@/store/tradeDataStoreACTIONS";
import { ColDef } from "ag-grid-community";
import {
  caluclatePercentageQuoteSizeER,
  isCPIEditable,
  isStrikeEditable,
  returnColDefsAsNewArray,
  tradeHasBondOrBondOption,
} from "../actionSummaryColDefHelperFunctions";
import { applyColumnWidthMultiplier } from "../actionSummaryHelper";
import { IColDefsObject } from "../actionSummaryMainTableColDefs";
import CPICellEditor from "../cellEditors/CPICellEditor";
import StrikeCellEditor from "../cellEditors/StrikeCellEditor";
import BookCellRenderer from "../cellRenderers/BookCellRenderer";
import CashCellRenderer from "../cellRenderers/CashCellRenderer";
import CouponActionSummarySwapCellRenderer from "../cellRenderers/CouponActionSummarySwapCellRenderer";
import { couponCellValueFormatter } from "../cellRenderers/CouponActionSummarySwapCellRenderer/couponActionSummarySwapFormatter";
import CPICellRenderer from "../cellRenderers/CPICellRenderer";
import CpiIndexCellRenderer from "../cellRenderers/CpiIndexCellRenderer";
import DealerCellRenderer from "../cellRenderers/DealerCellRenderer";
import { dealerCellValueFormatter } from "../cellRenderers/dealerCellFormatter";
import { cashCellValueFormatter } from "../cellRenderers/cashCellFormatter";
import { dealtFeeCellValueFormatter } from "../cellRenderers/dealtFeeCellFormatter";
import DealtFeeCellRenderer from "../cellRenderers/DealtFeeCellRenderer";
import DealtPriceCellRenderer from "../cellRenderers/DealtPriceCellRenderer";
import { dealtPriceValueFormatter } from "../cellRenderers/DealtPriceCellRenderer/dealtPriceFormatter";
import DealtPriceHeader from "../cellRenderers/DealtPriceHeader";
import {
  CurrentCouponCellRenderer,
  QuotedMarginCellRenderer,
  ReferenceIndexCellRenderer,
} from "../cellRenderers/FRNBlockCellRenderers";
import {
  currentCouponValueFormatter,
  quotedMarginValueFormatter,
  referenceIndexValueFormatter,
} from "../cellRenderers/FRNBlockCellRenderers/frnBlockFormatter";
import DirectionCellRenderer from "../cellRenderers/DirectionCellRenderer/index";
import { directionValueFormatter } from "../cellRenderers/DirectionCellRenderer/directionFormatter";
import ExecutionFeeCellRenderer from "../cellRenderers/ExecutionFeeCellRenderer";
import ExpandCollapseAllERHeader from "../cellRenderers/ExpandCollapseAllERHeader";
import ExpiryDateCellRenderer from "../cellRenderers/ExpiryDateCellRenderer";
import LevelCellRenderer from "../cellRenderers/LevelCellRenderer";
import { levelValueFormatter } from "../cellRenderers/LevelCellRenderer/levelFormatter";
import NotionalLeg1 from "../cellRenderers/NotionalLeg1";
import { notionalLeg1ValueFormatter } from "../cellRenderers/NotionalLeg1/notionalLeg1Formatter";
import { notionalLeg1TooltipValueGetter } from "../cellRenderers/NotionalLeg1/notionalLeg1Tooltip";
import OrderCellRenderer from "../cellRenderers/OrderCellRenderer";
import ProviderCellRenderer from "../cellRenderers/ProviderCellRenderer";
import QuotedPercentCellRenderer from "../cellRenderers/QuotedPercentCellRenderer";
import { quotedPercentValueFormatter } from "../cellRenderers/QuotedPercentCellRenderer/quotedPercentFormatter";
import IcebergCellRenderer from "../cellRenderers/IcebergCellRenderer";
import IcebergCellEditor from "../cellRenderers/IcebergCellRenderer/IcebergCellEditor";
import { icebergValueFormatter } from "../cellRenderers/IcebergCellRenderer/icebergFormatter";
import { isIcebergCellEditable } from "../cellRenderers/IcebergCellRenderer/icebergHelpers";
import QuoteCellRenderer from "../cellRenderers/QuoteCellRenderer";
import ReferenceRatesCellRenderer from "../cellRenderers/ReferenceRatesCellRenderer";
import SettlementDateCellRenderer from "../cellRenderers/SettlementDateCellRenderer";
import { settlementDateValueFormatter } from "../cellRenderers/SettlementDateCellRenderer/settlementDateFormatter";
import StrikeCellRenderer from "../cellRenderers/StrikeCellRenderer";
import UnwindTypeCellRenderer from "../cellRenderers/UnwindTypeCellRenderer";
import { returnTrueIfCellCanBeEdited } from "../columnHelpers/cellCanBeEdited";
import { ColId } from "../ENUMActionSummaryColIds";
import CPTooltip from "../tooltips/CPTooltip";
import { displayYieldTooltipForAllQuoteLevels } from "../tooltips/tooltipHelperFunctions";
import ReferenceRateTooltip from "../tooltips/ReferenceRateTooltip";
import {
  quoteValueFormatter,
  statusAtAffirmedRange,
  statusAtExecutedRange,
  statusFormExecutedToAffirmedRange,
  statusFromAwarded,
  statusToShowDealtPrice,
  tradeHasIceberg,
  tradeHasReducedQuotedSize,
} from "./colDefsShared";
import CashDealerTooltip from "../tooltips/CashDealerTooltip";
import { feeAdjustedYieldTooltipValueGetter } from "../tooltips/FeeAdjustedYieldTooltip";

export function returnExecutionRequestColDefsOP({
  theme,
  fullTradeData,
  getAccessTokenSilently,
  columnWidthMultiplier = 1.0,
}: IColDefsObject) {
  const isOrder = fullTradeData?.type === TradeType.Order;

  const executionRequestColDefsOP = [
    {
      field: "",
      headerName: " ",
      width: defaultColumnWidths.expandArrow,
      fixedWidth: true,
      cellRenderer: isOrder ? () => null : "agGroupCellRenderer",
      resizable: false,
      suppressMovable: true,
      // pinned: "left",
      colId: ColId.expand,
      cellClass: "detailExpandCellRendererArrow",
      headerClass: "fixedWidthHeader",
      mainMenuItems: ["resetColumns"],
      headerComponent: isOrder ? undefined : ExpandCollapseAllERHeader,
    },
    {
      field: "",
      headerName: " ",
      width: defaultColumnWidths.expandArrow,
      fixedWidth: true,
      resizable: false,
      suppressMovable: true,
      // pinned: "left",
      colId: ColId.expandMocked,
      cellClass: "detailExpandCellRendererArrow",
      headerClass: "fixedWidthHeader",
      mainMenuItems: ["resetColumns"],
    },
    {
      field: "order", // Only Order over 4 tables.
      headerName: TableHeaderField.orderEmptyHeader, // Changed to be: ""
      colId: ColId.order,
      width: defaultColumnWidths.order,
      extraScaling: true,
      resizable: false,
      suppressMovable: true,
      cellClass: "reducedPaddingLeft reducedPaddingRight",
      headerClass: "fixedWidthHeader",
      valueFormatter: OrderCellRenderer,
    },
    {
      field: "bid",
      tooltipValueGetter: displayYieldTooltipForAllQuoteLevels,
      headerValueGetter: () => {
        const structureType = fullTradeData.structureType;
        if (
          structureType == StructureTypeCode.SYNREPO ||
          structureType == StructureTypeCode.SYNREVREP
        ) {
          return "Repo Bid";
        } else {
          return "Bid";
        }
      },
      colId: ColId.bid,
      cellClass: "ag-roundedInputStyle",
      width: defaultColumnWidths.quoteField,
      cellRendererParams: { fullTradeData: fullTradeData, tableLevel: "ER" },
      cellRenderer: QuoteCellRenderer,
      valueFormatter: quoteValueFormatter,
    },
    {
      field: "ask",
      tooltipValueGetter: displayYieldTooltipForAllQuoteLevels,
      headerValueGetter: () => {
        const structureType = fullTradeData.structureType;
        if (
          structureType == StructureTypeCode.SYNREPO ||
          structureType == StructureTypeCode.SYNREVREP
        ) {
          return "Repo Ask";
        } else {
          return "Ask";
        }
      },
      colId: ColId.ask,
      cellClass: "ag-roundedInputStyle",
      width: defaultColumnWidths.quoteField,
      cellRendererParams: { fullTradeData: fullTradeData, tableLevel: "ER" },
      cellRenderer: QuoteCellRenderer,
      valueFormatter: quoteValueFormatter,
    },
    {
      field: "mid",
      tooltipValueGetter: displayYieldTooltipForAllQuoteLevels,
      headerValueGetter: () => {
        const structureType = fullTradeData.structureType;
        if (
          structureType == StructureTypeCode.SYNREPO ||
          structureType == StructureTypeCode.SYNREVREP
        ) {
          return "Repo Mid";
        } else {
          return "Mid";
        }
      },
      colId: ColId.mid,
      cellClass: "ag-roundedInputStyle",
      width: defaultColumnWidths.quoteField,
      cellRendererParams: { fullTradeData: fullTradeData, tableLevel: "ER" },
      cellRenderer: QuoteCellRenderer,
      valueFormatter: quoteValueFormatter,
    },
    {
      field: "feeAdjustedQuote",
      headerComponent: DealtPriceHeader, //TableHeaderField.feeAdjustedQuote normally - TableHeaderField.dealtRepoRate if SYN repo.
      headerComponentParams: { fullTradeData: fullTradeData },
      colId: ColId.feeAdjustedQuote,
      width: defaultColumnWidths.feeAdjustedQuote,
      cellRenderer: DealtPriceCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
      valueFormatter: dealtPriceValueFormatter,
      tooltipValueGetter: feeAdjustedYieldTooltipValueGetter
    },
    // {
    //   // TODO: Used for NPV Outrights?
    //   field: "feeAdjustedQuote",
    //   headerComponent: DealtPriceHeader, //TableHeaderField.feeAdjustedQuote normally - TableHeaderField.dealtRepoRate if SYN repo.
    //   headerComponentParams: { fullTradeData: fullTradeData },
    //   colId: ColId.feeAdjustedQuoteOutright,
    //   width: defaultColumnWidths.feeAdjustedQuote,
    //   cellRenderer: DealtPriceCellRenderer,
    //   cellRendererParams: { fullTradeData: fullTradeData },
    // },
    {
      field: "dealtStrike",
      headerName: TableHeaderField.dealtStrike,
      width: defaultColumnWidths.strike,
      colId: ColId.dealtStrikeOutright,
      editable: (params: any) =>
        isStrikeEditable({ esid: fullTradeData.esid, params: params }),
      cellStyle: { padding: "0px" },
      cellClass: "ag-roundedInputStyle ",
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: StrikeCellRenderer,
      cellEditor: StrikeCellEditor,
    },
    {
      // NEW OIS 13608
      field: "referenceRates",
      headerName: TableHeaderField.ReferenceRates,
      colId: ColId.referenceRates,
      width: defaultColumnWidths.referenceRate,
      cellRenderer: ReferenceRatesCellRenderer,
      cellRendererParams: {
        fullTradeData: fullTradeData,
      },
      tooltipField: "provider", // No field to map to (Needs CP to be populated to show).
      tooltipComponent: ReferenceRateTooltip,
    },
    {
      field: "unwind",
      headerName: TableHeaderField.unwind,
      extraLargeScaling: true,
      colId: ColId.unwind,
      width: defaultColumnWidths.unwind,
      cellRenderer: UnwindTypeCellRenderer,
      valueFormatter: (params: any) => params.value,
      cellRendererParams: { fullTradeData: fullTradeData },
    },
    {
      field: "dealer",
      headerName: TableHeaderField.dealer,
      colId: ColId.dealer,
      headerClass: "noRightBorder",
      cellRenderer: DealerCellRenderer,
      valueFormatter: dealerCellValueFormatter,
      cellRendererParams: { fullTradeData: fullTradeData, theme: theme },
      width: defaultColumnWidths.dealer,
      tooltipValueGetter: (params: any) => params.data ? "dealer" : null,
      tooltipComponent: CashDealerTooltip,
    },
    {
      field: "cash",
      headerName: TableHeaderField.cash,
      colId: ColId.cash,
      // cellEditor: CashCellEditor, // OP Might not need to edit the Cash field.
      cellRenderer: CashCellRenderer,
      valueFormatter: cashCellValueFormatter,
      cellRendererParams: { fullTradeData: fullTradeData },
      width: defaultColumnWidths.cash,
      // tooltipField: "provider",
      tooltipValueGetter: (params: any) => params.data ? "cash" : null,
      tooltipComponent: CashDealerTooltip,
    },
    {
      field: "dealtFee", //npv Cash(fee inc),
      headerName: TableHeaderField.dealtFee,
      colId: ColId.dealtFeeOutright,
      width: defaultColumnWidths.dealtFee,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: DealtFeeCellRenderer,
      valueFormatter: dealtFeeCellValueFormatter,
      tooltipValueGetter: (params: any) => params.data ? "dealtFee" : null,
      tooltipComponent: CashDealerTooltip,
    },
    {
      field: "executionFee", // Outright
      headerName: TableHeaderField.executionFee,
      colId: ColId.executionFeeOutright,
      width: defaultColumnWidths.executionFee,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: ExecutionFeeCellRenderer,
    },
    // {
    //   field: "indicativeCash", // NPV STYLE
    //   // field: "indicativeFee",
    //   colId: ColId.indicativeCash,
    //   headerName: TableHeaderField.indicativeCash,
    //   width: defaultColumnWidths.indicativeCash,
    //   cellRenderer: IndicativeCashCellRenderer,
    //   cellRendererParams: { fullTradeData: fullTradeData },
    // },

    {
      field: "provider", // Only 1 Order over 4 tables.
      headerName: TableHeaderField.provider,
      colId: ColId.provider,
      width: defaultColumnWidths.provider,
      cellRenderer: ProviderCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
      tooltipField: "provider",
      tooltipComponent: CPTooltip,
    },
    {
      field: "status", // Only 1 status over 4 tables.
      headerName: TableHeaderField.status,
      colId: ColId.status,
      width: defaultColumnWidths.status,
    },

    {
      field: "direction",
      headerName: TableHeaderField.direction,
      colId: ColId.direction,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: DirectionCellRenderer,
      valueFormatter: directionValueFormatter,
      width: defaultColumnWidths.side,
    },
    {
      field: "coupon", // OUTRIGHT - 14614
      headerName: TableHeaderField.coupon,
      colId: ColId.couponOutright,
      width: defaultColumnWidths.coupon,
      cellRenderer: CouponActionSummarySwapCellRenderer,
      valueFormatter: couponCellValueFormatter,
      cellRendererParams: { fullTradeData: fullTradeData },
    },
    {
      field: "notionalLeg1",
      headerName: TableHeaderField.notionalLeg1,
      colId: ColId.notionalLeg1,
      width: defaultColumnWidths.nominal,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: NotionalLeg1, // Only displaying outright values brought up for 'size'.
      valueFormatter: notionalLeg1ValueFormatter,
      tooltipValueGetter: notionalLeg1TooltipValueGetter,
    },
    {
      field: "quotedSize",
      headerName: TableHeaderField.quotedSize,
      colId: ColId.quotedSize,
      width: defaultColumnWidths.quotedSize,
      valueGetter: (params: any) => caluclatePercentageQuoteSizeER(params),
      valueFormatter: (params: any) => {
        return params.value
          ? `${returnPercentageFormatted(params.value)}%`
          : "";
      },
    },
    {
      // STRUCTURE — bar version of % quoted (aggregate across legs).
      // hide: true so unselected paths (returnColDefsAsNewArray's fallback)
      // don't surface the column; selection-array entries override with hide: false.
      field: "quotedSize",
      headerName: TableHeaderField.percentQuoted,
      colId: ColId.percentQuoted,
      width: defaultColumnWidths.percentQuoted,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: QuotedPercentCellRenderer,
      valueFormatter: quotedPercentValueFormatter,
      hide: true,
    },
    // IF wanting to merge "QuotedSize" - Suggested to have 2 RAFCE - 1 for the OP and 1 for the RP as there is no need to watch the Zustand store for op.
    {
      field: "quotedSize",
      headerName: TableHeaderField.quotedSize,
      colId: ColId.quotedSizeOutright,
      width: defaultColumnWidths.quotedSize,
      valueGetter: (params: any) => params.data?.legs?.[0]?.quotedSize,
      valueSetter: (params: any) => {
        if (params.data?.legs?.[0]) {
          if (params.data.legs[0].insrumentType == InstrumentTypeCode.FUT) {
            params.data.legs[0].quotedSize = Math.round(params.newValue);
          } else {
            params.data.legs[0].quotedSize = params.newValue;
          }
        }
        return false;
      },
      valueFormatter: (params: any) => {
        return params.value
          ? returnSizeFormatted(
              params.value,
              params.data?.legs?.[0]?.instrumentType,
            )
          : "";
      },
    },
    {
      // OUTRIGHT — bar version of % quoted (single-leg).
      // hide: true so unselected paths default to hidden; outright selection
      // arrays explicitly opt this in via ColId.percentQuotedOutright.
      field: "quotedSize",
      headerName: TableHeaderField.percentQuoted,
      colId: ColId.percentQuotedOutright,
      width: defaultColumnWidths.percentQuoted,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: QuotedPercentCellRenderer,
      valueFormatter: quotedPercentValueFormatter,
      hide: true,
    },
    {
      // STRUCTURE ER — iceberg per-CP releaseSize as centered "{N}%" text.
      // LQC-922 / LQC-1085. The rounded-pill styling lives in
      // IcebergCellRenderer (Zustand-reactive); cellClass is intentionally
      // omitted because AG Grid wouldn't re-evaluate it on in-place CP
      // status mutations and the pill stuck at non-editable statuses.
      // hide: true so unselected paths default to hidden; selection arrays
      // explicitly opt this in via ColId.percentIceberg.
      field: "releaseSize",
      headerName: TableHeaderField.percentIceberg,
      colId: ColId.percentIceberg,
      width: defaultColumnWidths.percentIceberg,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: IcebergCellRenderer,
      cellEditor: IcebergCellEditor,
      editable: isIcebergCellEditable,
      valueFormatter: icebergValueFormatter,
      hide: true,
    },
    {
      // OUTRIGHT ER — iceberg per-CP releaseSize as centered "{N}%" text.
      // LQC-922 / LQC-1085. Pill styling driven from the renderer; see
      // STRUCTURE ER colDef above.
      field: "releaseSize",
      headerName: TableHeaderField.percentIceberg,
      colId: ColId.percentIcebergOutright,
      width: defaultColumnWidths.percentIceberg,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: IcebergCellRenderer,
      cellEditor: IcebergCellEditor,
      editable: isIcebergCellEditable,
      valueFormatter: icebergValueFormatter,
      hide: true,
    },
    {
      field: "notionalLeg2", // should not be here on a structure so getting the data off the leg instead for outrights.
      colId: ColId.notionalLeg2Outright,
      headerName: TableHeaderField.notionalLeg2,
      // width: defaultColSizes.nominal,
      width: defaultColumnWidths.nominal,
      valueGetter: (params: any) => params.data.notionalLeg2,
      valueFormatter: (params: any) => {
        return params.value
          ? returnSizeFormatted(
              params.value,
              params.data?.legs?.[0]?.instrumentType,
            )
          : "";
      },
    },
    {
      field: "security",
      headerName: TableHeaderField.security,
      colId: ColId.securityOutright,
      width: defaultColumnWidths.name,
      // flex: 2,
      valueGetter: (params: any) => params.data?.legs?.[0]?.security, // data is ES level
      tooltipValueGetter: (params: any) => {
        return params.data?.legs?.[0]?.isin; // data is ES level
      },
    },
    // LQC-2153: FRN columns sit after Security - visibility controlled by tempCols (Outright RFQ)
    {
      field: "referenceIndex",
      headerName: TableHeaderField.referenceIndex,
      colId: ColId.referenceIndexOutright,
      width: defaultColumnWidths.referenceIndex,
      cellRenderer: ReferenceIndexCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
      valueGetter: (params: any) => params.data?.legs?.[0]?.referenceIndex, // data is ES level
      valueFormatter: referenceIndexValueFormatter,
    },
    {
      field: "quotedMargin",
      headerName: TableHeaderField.quotedMargin,
      colId: ColId.quotedMarginOutright,
      width: defaultColumnWidths.quotedMargin,
      cellRenderer: QuotedMarginCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
      valueGetter: (params: any) => params.data?.legs?.[0]?.quotedMargin, // data is ES level
      valueFormatter: quotedMarginValueFormatter,
    },
    {
      field: "coupon", // FRN Current Coupon reuses the block coupon
      headerName: TableHeaderField.currentCoupon,
      colId: ColId.currentCouponOutright,
      width: defaultColumnWidths.currentCoupon,
      cellRenderer: CurrentCouponCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
      valueGetter: (params: any) => params.data?.legs?.[0]?.coupon, // data is ES level
      valueFormatter: currentCouponValueFormatter,
    },
    // LQC-227: ISIN column for bond trades — visibility controlled by selection arrays
    {
      field: "isin",
      headerName: "ISIN",
      colId: ColId.isinOutright,
      width: 150,
      valueGetter: (params: any) => params.data?.legs?.[0]?.isin,
    },
    {
      field: "settlementDate",
      colId: ColId.settlementDateOutright,
      headerName: TableHeaderField.settlementDate,
      extraScaling: true,
      width: defaultColumnWidths.date,
      editable: (params: any) =>
        returnTrueIfCellCanBeEdited(params.data.status),
      cellStyle: { padding: "0px" },
      cellClass: "ag-roundedInputStyle",
      valueGetter: (params: any) => params.data?.legs?.[0]?.settlementDate,
      valueSetter: (params: any) => {
        if (params.data?.legs?.[0]) {
          params.data.legs[0].settlementDate = params.newValue;
          // To be used with the RP changing status.
          updateSettlementDate(
            fullTradeData.esid,
            params.data.executionRequestId,
            params.data.legs[0].blockId,
            params.newValue,
            getAccessTokenSilently,
          );
        }
        return false;
      },
      cellRenderer: SettlementDateCellRenderer,
      cellRendererParams: { fullTradeData },
      valueFormatter: settlementDateValueFormatter,
      cellDataType: "dateString",
    },
    {
      field: "expiryDate",
      colId: ColId.expiryDate,
      headerName: TableHeaderField.expiryDate,
      width: defaultColumnWidths.date,
      cellRenderer: ExpiryDateCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
    },
    {
      field: "cpi",
      headerName: TableHeaderField.cpiLeg1,
      colId: ColId.cpiLeg1Outright,
      width: defaultColumnWidths.cpi,
      editable: () => isCPIEditable({ esid: fullTradeData.esid }),
      cellStyle: { padding: "0px" },
      cellClass: "ag-roundedInputStyle",
      cellRenderer: CPICellRenderer,
      cellEditor: CPICellEditor,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellDataType: "number",
    },
    {
      field: "cpiIndex",
      headerName: TableHeaderField.cpiIndex,
      colId: ColId.cpiIndexOutright,
      width: defaultColumnWidths.cpiIndex,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: CpiIndexCellRenderer,
    },
    {
      field: "lastAction", // Only 1 lastAction over 4 tables.
      headerName: TableHeaderField.latestActivity,
      colId: ColId.lastAction,
      width: defaultColumnWidths.status,
    },
    {
      field: "referenceSpread",
      headerName: TableHeaderField.level,
      colId: ColId.level,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: LevelCellRenderer,
      valueFormatter: levelValueFormatter,
      width: defaultColumnWidths.level,
    },
    {
      field: "refPrice",
      headerName: TableHeaderField.refPrice,
      colId: ColId.refPrice,
    },
    // {
    //   field: "filledPercent",
    //   headerName: TableHeaderField.filledPercent,
    //   colId: ColId.filledPercent,
    //   width: defaultColumnWidths.filledPercent,
    // },

    {
      field: "book",
      headerName: TableHeaderField.book,
      colId: ColId.book,
      width: defaultColumnWidths.book,
      cellRenderer: BookCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
    },

    ...fillerColDef,
  ];

  const status = fullTradeData.status;
  const type = fullTradeData.type;

  const structureType = fullTradeData.structureType;
  const strategyType = fullTradeData.strategyType;
  const securityType =
    fullTradeData.executionRequestCounterParties?.length > 0 &&
    fullTradeData.executionRequestCounterParties[0]?.legs?.length > 0 //checking that trade is not at new status (won't have any ERCPs)
      ? fullTradeData.executionRequestCounterParties[0].legs[0].securityType
      : ""; // for outrights

  const instrumentType =
    fullTradeData.executionRequestCounterParties?.length > 0 &&
    fullTradeData.executionRequestCounterParties[0]?.legs?.length > 0 //checking that trade is not at new status (won't have any ERCPs)
      ? fullTradeData.executionRequestCounterParties[0].legs[0].instrumentType
      : ""; // for outrights
  let colDefsToReturn: ColDef | any = [];

  // NEW - MOVING towards a goal state of consitant defs.
  const commonColDefsOPLevelERForRFQ = [
    ColId.provider,
    ColId.status,
    ColId.order,
    ColId.lastAction,
    // QUOTE expiry, a later phase. No base colDef exists so this renders
    // nothing. See docs/features/TRADE_EXPIRY.md
    ColId.validUntil,
  ];
  const unwind = fullTradeData.unwind;
  let containsRecoupon = false;
  let containsNPV = false;
  if (
    fullTradeData.executionRequestCounterParties?.length > 0 &&
    fullTradeData.executionRequestCounterParties[0]?.legs
  ) {
    fullTradeData.executionRequestCounterParties[0].legs.forEach((leg: any) => {
      if (leg.unwind == "Recoupon") {
        containsRecoupon = true;
      }
      if (leg.unwind == "NPV") {
        containsNPV = true;
      }
    });
  }
  //  Default NPV and RECOUPON arrrays used to store related show/hide information.
  const columnsToShowForNPVorRecoupon: ColId[] = []; // USED FOR NPV / Recoupon to prevent cols later getting added.
  const columnsToHideForNPVorRecoupon: ColId[] = []; // USED FOR NPV / Recoupon to prevent cols later getting added.

  const dealtPriceCols: any[] = [];
  if (statusToShowDealtPrice.includes(status)) {
    dealtPriceCols.push(ColId.feeAdjustedQuote);
  }
  const bookCols: any[] = [];
  if (statusFromAwarded.includes(status)) {
    bookCols.push(ColId.book);
  }
  if (status == "New") {
    const colsAtNew = [ColId.expand, ColId.provider, ColId.status];
    colDefsToReturn = returnColDefsAsNewArray(
      executionRequestColDefsOP,
      colsAtNew,
      columnsToShowForNPVorRecoupon,
      columnsToHideForNPVorRecoupon,
    );
  } else if (
    type == TradeType.NotSent &&
    status == ExecutionStrategyStatus.NotDealt
  ) {
    const colDefsAtClosed = [ColId.status];

    colDefsToReturn = returnColDefsAsNewArray(
      executionRequestColDefsOP,
      colDefsAtClosed,
      columnsToShowForNPVorRecoupon,
      columnsToHideForNPVorRecoupon,
    );
  } else if (type == "RFQ") {
    // if (structureType == StructureTypeCode.NPVPACK) {

    if (strategyType == StrategyType.Outright && unwind == false) {
      if (containsNPV || containsRecoupon) {
        columnsToShowForNPVorRecoupon.push(ColId.unwind);
      }
    }

    if (unwind == true) {
      // NPV STYLE - ALL Status'
      // Bid, Ask and Mid hidden through the whole trade.
      // HIDE - 14170, 14231, 14239
      columnsToHideForNPVorRecoupon.push(
        ColId.bid,
        ColId.bidOutright,
        ColId.ask,
        ColId.askOutright,
        ColId.mid,
        ColId.midOutright,
        // May need to add the Dealt Price back in - Q pending with Jonty.
        ColId.feeAdjustedQuote,
      );

      if (!statusFormExecutedToAffirmedRange.includes(status)) {
        // SHOW - 14170
        columnsToShowForNPVorRecoupon.push(
          ColId.dealer,
          ColId.cash,
          ColId.indicativeCash,
        );
      } else if (statusAtExecutedRange.includes(status)) {
        // 14231 - SHOW Cols for NPV Style.
        columnsToShowForNPVorRecoupon.push(ColId.dealer, ColId.cash);
      } else if (statusAtAffirmedRange.includes(status)) {
        // 14239 SHOW
        columnsToShowForNPVorRecoupon.push(ColId.dealer, ColId.cash);
      }
    } else if (
      unwind == false &&
      containsNPV &&
      strategyType == StrategyType.Outright
    ) {
      // OUTRIGHT NPV BLOCK
      // 14571 “Sent” to “Awarded”
      if (!statusFormExecutedToAffirmedRange.includes(status)) {
        // 14571 - NPV Outright
        columnsToShowForNPVorRecoupon.push(
          ColId.dealer,
          ColId.cash,
          ColId.couponOutright,
          ColId.indicativeCash, // Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
        );
      } else if (statusAtExecutedRange.includes(status)) {
        // 14575 NPV Outright SHOW at Executed
        columnsToShowForNPVorRecoupon.push(
          ColId.dealer,
          ColId.cash,
          ColId.executionFeeOutright, //New at Executed. // Check
          ColId.couponOutright,
          ColId.indicativeCash, // Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
          ColId.feeAdjustedQuote,
        );
        // 14575 NPV Outright Hide at Executed
        // columnsToHideForNPVorRecoupon.push(ColId.feeAdjustedQuote);
      } else if (statusAtAffirmedRange.includes(status)) {
        // 14579 NPV Outright SHOW at Executed

        columnsToShowForNPVorRecoupon.push(
          ColId.feeAdjustedQuote, // New at Affirmed
          ColId.dealer,
          ColId.dealtFeeOutright, // New at Affirmed - Replaces CASH
          ColId.coupon,
          ColId.indicativeCash, // Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
        );
      }
    } else if (unwind == false && containsNPV) {
      if (!statusFormExecutedToAffirmedRange.includes(status)) {
        // 14281 - NO Changes to ER.
      } else if (statusAtExecutedRange.includes(status)) {
        // 14285 - NO Changes to ER.
      } else if (statusAtAffirmedRange.includes(status)) {
        // 14289 - NO Changes to the ER.
      }
    }

    // OUTRIGHT case for ReCoupon will be inside this Logic block also:
    if (unwind == false && containsRecoupon) {
      // 14247 && 14585 remove the dealt price
      // Dealt price removed for all trade types at Exectued.
      // if (statusAtExecutedRange.includes(status)) {
      //   columnsToHideForNPVorRecoupon.push(ColId.feeAdjustedQuote);
      // }
      if (strategyType == StrategyType.Outright) {
        if (
          statusAtExecutedRange.includes(status) ||
          status == ExecutionStrategyStatus.Awarded // #14876, #14877, #14878, #14879, #14880, #14881 - Moving ReCoupon showing on Dealer and Cash cells forward to Awarded.
        ) {
          // 14585
          columnsToShowForNPVorRecoupon.push(
            ColId.dealer,
            ColId.cash,
            ColId.couponOutright,
            ColId.indicativeCash, // Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
          );
          // Only show fee once Exectued
          if (statusAtExecutedRange.includes(status)) {
            columnsToShowForNPVorRecoupon.push(ColId.executionFeeOutright);
          }
        } else if (statusAtAffirmedRange.includes(status)) {
          // 14589 && 14591
          columnsToShowForNPVorRecoupon.push(
            ColId.dealer,
            ColId.dealtFeeOutright, // Cash (fee inc)
            ColId.couponOutright,
            ColId.indicativeCash, // Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
          );
        }
      }
    }

    // START OF IF statements AFTER all of the NPV and Recoupon data has been handled.
    if (
      structureType == StructureTypeCode.SYNREPO ||
      structureType == StructureTypeCode.SYNREVREP
    ) {
      if (statusFormExecutedToAffirmedRange.includes(status)) {
        const colsForSYNRREPOWithDealtRepo = [
          ColId.expand,
          ColId.bid,
          ColId.ask,
          ColId.mid,
          ...commonColDefsOPLevelERForRFQ,
          ColId.feeAdjustedQuote, //ColId.dealtRepoRate,
          ColId.quotedSize,
          // LQC-275: % Quoted column disabled on OP ER until RP-side behaviour is finalised
          // ...(tradeHasReducedQuotedSize(fullTradeData) ? [ColId.percentQuoted] : []),
          ...(tradeHasIceberg(fullTradeData) ? [ColId.percentIceberg] : []),
          ColId.referenceRates,
        ];
        colDefsToReturn = returnColDefsAsNewArray(
          executionRequestColDefsOP,
          colsForSYNRREPOWithDealtRepo,
          columnsToShowForNPVorRecoupon,
          columnsToHideForNPVorRecoupon,
        );
      } else {
        // Syn Repo, RevSynRepo
        const colsForSYNRREPO = [
          ColId.expand,
          ...commonColDefsOPLevelERForRFQ,
          ColId.bid,
          ColId.ask,
          ColId.mid,
          ColId.quotedSize,
          // LQC-275: % Quoted column disabled on OP ER until RP-side behaviour is finalised
          // ...(tradeHasReducedQuotedSize(fullTradeData) ? [ColId.percentQuoted] : []),
          ...(tradeHasIceberg(fullTradeData) ? [ColId.percentIceberg] : []),
          ColId.referenceRates,
        ];
        colDefsToReturn = returnColDefsAsNewArray(
          executionRequestColDefsOP,
          colsForSYNRREPO,
          columnsToShowForNPVorRecoupon,
          columnsToHideForNPVorRecoupon,
        );
      }
    } else if (strategyType == StrategyType.Outright) {
      const tempCols = [];
      if (
        securityType == SecurityTypeCode.SWO ||
        securityType == SecurityTypeCode.BNDO
      ) {
        tempCols.push(ColId.dealtStrikeOutright);
      }
      if (securityType == SecurityTypeCode.ZCS) {
        tempCols.push(
          ColId.expandMocked,
          ...commonColDefsOPLevelERForRFQ,
          ColId.bid,
          ColId.ask,
          ColId.mid,
          ColId.direction,
          ColId.notionalLeg1,
          ColId.cpiLeg1Outright,
          ColId.cpiIndexOutright,
          ColId.settlementDateOutright,
          ColId.quotedSizeOutright,
          ...(tradeHasReducedQuotedSize(fullTradeData) ? [ColId.percentQuotedOutright] : []),
          ...(tradeHasIceberg(fullTradeData) ? [ColId.percentIcebergOutright] : []),
          ...bookCols,
          ColId.securityOutright,
          ...(tradeHasBondOrBondOption(fullTradeData)
            ? [ColId.isinOutright]
            : []),
          ...dealtPriceCols,
        );
      } else if (
        securityType == SecurityTypeCode.XCS ||
        securityType == SecurityTypeCode.XBS
      ) {
        tempCols.push(
          ColId.expandMocked,
          ...commonColDefsOPLevelERForRFQ,
          ColId.bid,
          ColId.ask,
          ColId.mid,
          ColId.direction,
          ColId.notionalLeg1,
          ColId.notionalLeg2Outright,
          ColId.settlementDateOutright,
          ColId.quotedSizeOutright,
          ...(tradeHasReducedQuotedSize(fullTradeData) ? [ColId.percentQuotedOutright] : []),
          ...(tradeHasIceberg(fullTradeData) ? [ColId.percentIcebergOutright] : []),
          ...bookCols,
          ColId.securityOutright,
          ...(tradeHasBondOrBondOption(fullTradeData)
            ? [ColId.isinOutright]
            : []),
          ...dealtPriceCols,
        );
      } else {
        tempCols.push(
          ColId.expandMocked,
          ...commonColDefsOPLevelERForRFQ,
          ColId.bid,
          ColId.ask,
          ColId.mid,
          ColId.direction,
          ColId.notionalLeg1,
          ColId.settlementDateOutright,
          ColId.quotedSizeOutright,
          ...(tradeHasReducedQuotedSize(fullTradeData) ? [ColId.percentQuotedOutright] : []),
          ...(tradeHasIceberg(fullTradeData) ? [ColId.percentIcebergOutright] : []),
          ...bookCols,
          ColId.securityOutright,
          ...(tradeHasBondOrBondOption(fullTradeData)
            ? [ColId.isinOutright]
            : []),
          ...dealtPriceCols,
        );
      }
      if (instrumentType == InstrumentTypeCode.OPT) {
        tempCols.push(ColId.expiryDate);
      }
      if (instrumentType == InstrumentTypeCode.FRN) {
        tempCols.push(
          ColId.referenceIndexOutright,
          ColId.quotedMarginOutright,
          ColId.currentCouponOutright,
        );
      }
      // will be used for outrights;
      colDefsToReturn = returnColDefsAsNewArray(
        executionRequestColDefsOP,
        tempCols,
        columnsToShowForNPVorRecoupon,
        columnsToHideForNPVorRecoupon,
      );
    } else {
      //colsForDefaultStructure
      const colsForDefaultStructure = [
        ColId.expand,
        ...commonColDefsOPLevelERForRFQ,
        ColId.bid,
        ColId.ask,
        ColId.mid,
        ColId.quotedSize,
        // LQC-275: % Quoted column disabled on OP ER until RP-side behaviour is finalised
        // ...(tradeHasReducedQuotedSize(fullTradeData) ? [ColId.percentQuoted] : []),
        ...(tradeHasIceberg(fullTradeData) ? [ColId.percentIceberg] : []),
        ...dealtPriceCols,
      ];
      colDefsToReturn = returnColDefsAsNewArray(
        executionRequestColDefsOP,
        colsForDefaultStructure,
        columnsToShowForNPVorRecoupon,
        columnsToHideForNPVorRecoupon,
      );
    }
  } else if (type == "Order") {
    const commonColDefsORLevelERForOrder = [
      // ColId.direction,
      ColId.provider,
      ColId.status,
      ColId.lastAction,
    ];
    // Remove the ColId.direction from the commonColDefsORLevelERForOrder array.
    // if (strategyType == StrategyType.Structure) {
    //   commonColDefsORLevelERForOrder = commonColDefsORLevelERForOrder.filter(
    //     (col) => col !== ColId.direction,
    //   );
    // }

    const colsForOrderOPErLevel = [
      ColId.expand,
      ...commonColDefsORLevelERForOrder, // NOT RFQ
      ColId.level,
      ColId.filledPercent,
      ...(tradeHasIceberg(fullTradeData) ? [ColId.percentIceberg] : []),
      ...dealtPriceCols,
    ];
    colDefsToReturn = returnColDefsAsNewArray(
      executionRequestColDefsOP,
      colsForOrderOPErLevel,
      columnsToShowForNPVorRecoupon,
      columnsToHideForNPVorRecoupon,
    );
  }

  return applyColumnWidthMultiplier(colDefsToReturn, columnWidthMultiplier);
}
